import CanvasObject from './CanvasObject';
import { roundRect, isInside, allInside, doPolygonsIntersect } from './canvas-helper';
import { CANVAS_ACTIONS } from './canvasActionTypes';
import AppSettings from '../AppSettings';

import { STOCK_IMAGE, CUSTOM_IMAGE, CARD, LOGO, SIGNATURE } from './itemTypes'

class Card extends CanvasObject {
	constructor(ctx, options = {}) {
		super();
		this.ctx = ctx;
		this.isMetalSkin = options.isMetalSkin;
		this.isUploadOnly = options.uploadOnlyMode;

		this.layerType = STOCK_IMAGE;
		this.type = CARD;
		this.cardarea = options.cardArea;
		this.coverageArea = options.coverageArea;

		this.template = options.templateArea;
		this.options = options;

		this.bleed = this.options.bleed || 10;

		this.coverageColour =  options.coverageColor || '#55deff99';
		this.coverageBorderwidth = this.bleed;

		//origin point center of image  relates to center of template (center of canvas)
		this.originPoint = {
			x: 0,
			y: 0
		};
		this.imageOpacity = options.imageOpacity || 0.4;

		// No need to put extra 20px in case of metal
		//if ((typeof (this.isMetalSkin) != undefined && this.isMetalSkin != null)) {
		if (this.isMetalSkin) {
			this.width = this.cardarea.width;
			this.height = this.cardarea.height;
		}
		else {
			this.width = this.cardarea.width + 20;
			this.height = this.cardarea.height + 20;
		}

		this.cardScale = 1;


		this.locked = false;
		this.selected = true;
		this.imageLoaded = false;
		this.rotation = 0; 
		this.borderColor = options.borderColor || 'rgb(49, 183, 219)';

		if (options.image) {
			this.setImage(options.image.id, options.image.url);
		}
	}

	reset(w,h) {

		this.locked = false;
		this.rotation = (this.isPortrait && this.layerType === STOCK_IMAGE )? 90 : 0;
		this.originPoint = {
			x: 0,
			y: 0
		};
		let defaultW, defaultH;

		// No need to put extra 20px in case of metal
		if (this.isMetalSkin) {
			defaultW = this.cardarea.width;
			defaultH = this.cardarea.height;
		}
		else {
			defaultW = this.cardarea.width + 20;
			defaultH = this.cardarea.height + 20;
		}

		if(w && h){

			// ------------ set aspect ratio fit within coverage area ---------------
			let defaultARatio = this.cardarea.width/this.cardarea.height;
			let imageARatio = w/h;

			if(this.options.isPortrait){
				imageARatio = h/w;

				if(this.layerType === STOCK_IMAGE)
						{ w = defaultH, h = defaultH * imageARatio	} 
				else {
					if(imageARatio >= defaultARatio) {
						{ h = defaultH,  w = defaultH/imageARatio 	}
					}
					else {
						{ h = defaultH,  w = defaultH/imageARatio	}
					}
				}

			} else {
				if(imageARatio >= defaultARatio)
					{ h = defaultH, w = defaultH * imageARatio	}
				else
					{ h = defaultW/imageARatio,   w = defaultW	} 
			}

			this.width = w;  
			this.height = h; 		
		}else{
			this.width = defaultW;
			this.height = defaultH;	
		}

		this.flipped = false;

		this.cardScale = 1;
		
		this.testCoverage();
	}

	undo(flag) {
		let effectValue;
		
		// flag = true when undo is for all effects
		if(flag) {
			let effect = AppSettings.undoEffectsArr;
			if(effect.length > 1) {
				effect.pop();
				if(AppSettings.undoCounterObj) {
					AppSettings.undoCounterObj.effects.pop();
				}
				
				effectValue = effect[effect.length - 1];
				this.undoEffects(effectValue);
			}
			else {
				return;
			}
		}

		// flag = false when undo is for specific effect
		else {
			effectValue = AppSettings.undoEffectsArr[AppSettings.undoEffectsArr.length - 1];
			this.undoEffects(effectValue);
		}
	}

	setSpecialEffect(specialEffectName, intensity, url) {
		const specialEffectImage = new Image();
		specialEffectImage.crossOrigin = 'Anonymous';
		specialEffectImage.src = url;
		specialEffectImage.onload = () => {
			this.specialEffectName = specialEffectName;
			this.specialEffectIntensity = intensity;
			this.specialEffectImage = specialEffectImage;
		}
	}

	undoEffects(effectValue) {
		this.locked = false;
		if(effectValue.rotation != null) {
			this.rotation = effectValue.rotation;
			document.querySelector('.aam-designer-init .designer-page .controls-container .input-container #rotate-control').value = effectValue.rotation;
		}
		if(effectValue.originPoint) {
			this.originPoint = {
				x: effectValue.originPoint.x,
				y: effectValue.originPoint.y
			}
		}
		if(effectValue.width) {
			this.width = effectValue.width;
			document.querySelector('.aam-designer-init .designer-page .controls-container .input-container #scale-control').value = effectValue.resizeValue;
		}
		if(effectValue.height) {
			this.height = effectValue.height;
		}
		if(effectValue.flipped != null) {
			this.flipped = effectValue.flipped;
		}
		if(effectValue.flippedV != null) {
			this.flippedV = effectValue.flippedV;
		}
		
		this.testCoverage();
	}

	removeSpecialEffects() {
		this.specialEffectImage = null;
		this.specialEffectIntensity = 0;
		this.specialEffectName = '';
	}

	getSpecialEffectName() {
		return this.specialEffectName;
	}

	//hide fade area when displaying canvas in feature palettes.
	hideFadeArea(sw){

		this.hideHandles = sw;
		this.imageOpacity = sw? 0 : 0.4;
		this.render(this.ctx);
		this.hideCoverage = sw;
	}

	getScale(){

		let cardScale = (this.width/(this.cardarea.width + (this.bleed * 2)));
		return cardScale;
	}

	getImageDimensions(){
		return {w:this.imgWidth, h:this.imgHeight }
	}

	setImage(id, url, imageType = STOCK_IMAGE) {

		this.id = id;
		this.layerType = imageType;
		this.isPortrait = (this.options.isPortrait && imageType === STOCK_IMAGE)

		this.specialEffectImage = null;

		const img = new Image();
		img.crossOrigin = 'Anonymous';
		img.src = url;

		return new Promise(resolve => {
			img.onload = () => {
				this.image = img;
				// always in center on canvas
				this.originPoint = {
					x: 0,
					y: 0
				};

				this.isUploadOnly =  false;

				//image's actual dimensions ----
				this.imgWidth = img.naturalWidth;
				this.imgHeight = img.naturalHeight;

				resolve(this.image)
			};
		});
	}

	render(ctx) {
		/*if (!this.image) {
			return;
		}*/

		const canvasCenter = {
			x: ctx.canvas.width / 2,
			y: ctx.canvas.height / 2
		};

		const renderedImage = this.specialEffectImage || this.image;

		ctx.save();
		ctx.translate(this.originPoint.x + canvasCenter.x, this.originPoint.y + canvasCenter.y);

		if (this.rotation !== 0) {
			ctx.rotate(this.rotation * Math.PI / 180);
		}

		// set opacity of fade area
		ctx.globalAlpha = this.imageOpacity;

		if (this.flipped) {
			ctx.scale(-1, 1);
		}

		if (this.flippedV) {
			ctx.scale(1, -1);
		}

		//faded image ----------------------
		if(!(this.isMetalSkin || this.isUploadOnly) && renderedImage) {
			ctx.drawImage(renderedImage, -this.width / 2, -this.height / 2, this.width, this.height); 
		}

		if (this.flipped) {
			// flip back whole canvas
			ctx.scale(-1, 1);
		}

		if (this.flippedV) {
			ctx.scale(1, -1);
		}

		ctx.globalAlpha = 1;

		if (this.selected && !this.locked && !this.hideHandles && !this.isUploadOnly ) {

			// draw border
			ctx.strokeStyle = this.borderColor;
			roundRect(ctx, -this.width / 2, -this.height / 2, this.width, this.height, 2);

			// draw left top corner handle
			ctx.beginPath();
			ctx.arc(-this.width / 2, -this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fillStyle = this.hoverCorners.leftTop ? this.borderColor : 'white';
			ctx.fill();
			ctx.stroke();

			// draw right top corner handle
			ctx.beginPath();
			ctx.arc(this.width / 2, -this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fillStyle = this.hoverCorners.rightTop ? this.borderColor : 'white';
			ctx.fill();
			ctx.stroke();

			//draw left bottom corner handle
			ctx.beginPath();
			ctx.fillStyle = this.hoverCorners.leftBottom ? this.borderColor : 'white';
			ctx.arc(-this.width / 2, this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fill();
			ctx.stroke();

			//draw right bottom corner handle
			ctx.beginPath();
			ctx.arc(this.width / 2, this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fillStyle = this.hoverCorners.rightBottom ? this.borderColor : 'white';
			ctx.fill();
			ctx.stroke();
		}

		ctx.restore();
		ctx.save();

		ctx.beginPath();

		//draw card boundary
		roundRect(ctx, canvasCenter.x - this.cardarea.width / 2, canvasCenter.y - this.cardarea.height / 2, this.cardarea.width, this.cardarea.height, (this.options.cardRadius ||this.cardarea.width/30));
		ctx.clip();

		ctx.translate(canvasCenter.x + this.originPoint.x, canvasCenter.y + this.originPoint.y);

		if (this.rotation !== 0) {
			ctx.rotate(this.rotation * Math.PI / 180);
		}

		if (this.flipped) {
			ctx.scale(-1, 1);
		}

		// Flip vertical
		if (this.flippedV) {
			ctx.scale(1, -1);
		}

		//card image --------------------------
		if(!(this.isMetalSkin || this.isUploadOnly) && renderedImage) {
			/*==================================================================
			Draw the card background (main) image.
			Params 2 & 3 determine position of image within the canvas area
			Params 4 & 5 determine the dimensions of the image 
			==================================================================*/
			ctx.drawImage(renderedImage, -this.width / 2, -this.height / 2, this.width, this.height);
		}

		// flip back whole canvas
		if (this.flipped) {
			ctx.scale(-1, 1);
		}

		if (this.flippedV) {
			ctx.scale(1, -1);
		}

		ctx.restore();

		const corners = {
			tl: 5, //((this.cardarea.x - this.coverageArea.x > 0) || (this.cardarea.y - this.coverageArea.y > 0))? 20 : 0, //to be done - only round corners if theyr'e at the edge of the card area
			bl: 5,
			tr: 5,
			br: 5
		}

		// coverage boundary ---------------------------------------------
		if (this.selected && !this.hideCoverage) {
			ctx.save();
			ctx.translate(canvasCenter.x, canvasCenter.y);

			ctx.strokeStyle = this.coverageColour;
			ctx.lineWidth = this.coverageBorderwidth;

			//roundRect(ctx, this.coverageArea.x , this.coverageArea.y, this.coverageArea.width, this.coverageArea.height, corners);
			roundRect(ctx, this.coverageArea.x + (this.bleed/2) , this.coverageArea.y + (this.bleed/2), this.coverageArea.width - this.bleed, this.coverageArea.height - this.bleed, corners);

			ctx.restore();
		}

	}

	testCoverage() {

		const bleedBox = {
			top: this.coverageArea.y, 
			left: this.coverageArea.x, 
			right: this.coverageArea.x + this.coverageArea.width,
			bottom: this.coverageArea.y + this.coverageArea.height
		}

		const vertices = [this.getLeftTopCorner(), this.getRightTopCorner(), this.getRightBottomCorner(), this.getLeftBottomCorner()];

		const r1 = allInside();
		const r2 = noOverlap();
		const r3 = linesIntersect();

		this.errorCoverage = r1 || r2 || r3;
		return this.errorCoverage;  //true if image doesn't cover card correctly

		function linesIntersect() {
			const imageLines = verticesToLines(vertices);

			const templateLines = verticesToLines([
				{ x: Math.round(bleedBox.left), y: Math.round(bleedBox.bottom) },
				{ x: Math.round(bleedBox.left), y: Math.round(bleedBox.top) },
				{ x: Math.round(bleedBox.right), y: Math.round(bleedBox.top) },
				{ x: Math.round(bleedBox.right), y: Math.round(bleedBox.bottom) }
			]);

			for (let i = 0; i < imageLines.length; i++) {
				for (let j = 0; j < templateLines.length; j++) {
					if (lineIntersect(

						Math.round(imageLines[i].p1.x),
						Math.round(imageLines[i].p1.y),
						Math.round(imageLines[i].p2.x),
						Math.round(imageLines[i].p2.y),
						templateLines[j].p1.x,
						templateLines[j].p1.y,
						templateLines[j].p2.x,
						templateLines[j].p2.y

					)
					) {
						return true;
					}
				}
			}

			return false;
		}

		//check if image is completely outside the bleed area
		function noOverlap() {
			return (vertices[0].y < bleedBox.top
				&& vertices[1].y < bleedBox.top
				&& vertices[2].y < bleedBox.top
				&& vertices[3].y < bleedBox.top)
				||
				(vertices[0].y > bleedBox.bottom
					&& vertices[1].y > bleedBox.bottom
					&& vertices[2].y > bleedBox.bottom
					&& vertices[3].y > bleedBox.bottom)
				||
				(vertices[0].x < bleedBox.left
					&& vertices[1].x < bleedBox.left
					&& vertices[2].x < bleedBox.left
					&& vertices[3].x < bleedBox.left)
				||
				(vertices[0].x > bleedBox.right
					&& vertices[1].x > bleedBox.right
					&& vertices[2].x > bleedBox.right
					&& vertices[3].x > bleedBox.right);
		}


		//check if whole image is within the bleed area 
		//and not in contact with the boundaries.
		function allInside() {
			return vertices[0].y > bleedBox.top
				&& vertices[1].y > bleedBox.top
				&& vertices[2].y > bleedBox.top
				&& vertices[3].y > bleedBox.top
				&& vertices[0].x > bleedBox.left
				&& vertices[1].x > bleedBox.left
				&& vertices[2].x > bleedBox.left
				&& vertices[3].x > bleedBox.left
				&& vertices[0].x < bleedBox.right
				&& vertices[1].x < bleedBox.right
				&& vertices[2].x < bleedBox.right
				&& vertices[3].x < bleedBox.right
				&& vertices[0].y < bleedBox.bottom
				&& vertices[1].y < bleedBox.bottom
				&& vertices[2].y < bleedBox.bottom
				&& vertices[3].y < bleedBox.bottom;
		}

		function verticesToLines(vertices) {
			const lines = [];

			for (let i = 0; i < vertices.length; i++) {
				let next = i + 1;
				if (next === vertices.length) {
					next = 0;
				}
				lines.push({ p1: vertices[i], p2: vertices[next] });
			}

			return lines;
		}

		//check if boundary of image intersects boundary of bleed area
		function lineIntersect(x1, y1, x2, y2, x3, y3, x4, y4) {
			const x = ((x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4)) / ((x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4));
			const y = ((x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4)) / ((x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4));

			/*if (isNaN(x) || isNaN(y)) {
				return false;
			} else {*/
				if (x1 >= x2) {
					if (!(x2 <= x && x <= x1)) {
						return false;
					}
				} else {
					if (!(x1 <= x && x <= x2)) {
						return false;
					}
				}
				if (y1 >= y2) {
					if (!(y2 <= y && y <= y1)) {
						return false;
					}
				} else {
					if (!(y1 <= y && y <= y2)) {
						return false;
					}
				}
				if (x3 >= x4) {
					if (!(x4 <= x && x <= x3)) {
						return false;
					}
				} else {
					if (!(x3 <= x && x <= x4)) {
						return false;
					}
				}
				if (y3 >= y4) {
					if (!(y4 <= y && y <= y3)) {
						return false;
					}
				} else {
					if (!(y3 <= y && y <= y4)) {
						return false;
					}
				}
			/*}*/
			return true;
		}

	}

	handleResize(scale) {

		this.cardarea.width *= scale;
		this.cardarea.height *= scale;

		this.coverageArea.x *= scale;
		this.coverageArea.y *= scale;
		this.coverageArea.width *= scale;
		this.coverageArea.height *= scale;

		const imageRatio = this.width / this.height;
		this.width *= scale;
		this.height = this.width / imageRatio;

		this.originPoint = {
			x: this.originPoint.x * scale,
			y: this.originPoint.y * scale
		};
	}

	// render image for preview
	preview(scale, ctx) {

		const { width, height } = ctx.canvas;

		const canvasCenter = {
			x: width / 2,
			y: height / 2
		};

		// clone card object
		const card = {
			image: this.specialEffectImage || this.image,
			width: this.width * scale.width,
			height: this.height * scale.height,
			rotation: this.rotation,
			flipped: this.flipped,
			flippedV: this.flippedV,
			originPoint: this.originPoint
		};

		ctx.save();
		ctx.translate(card.originPoint.x + canvasCenter.x, card.originPoint.y + canvasCenter.y);

		if (card.rotation !== 0) {
			ctx.rotate(card.rotation * Math.PI / 180);
		}
		if (card.flipped) {
			ctx.scale(-1, 1);
		}
		if (card.flippedV) {
			ctx.scale(1, -1);
		}

		ctx.drawImage(card.image, -card.width / 2, -card.height / 2, card.width, card.height);

		ctx.restore();
	}
}

export default Card;

//todo remove points for touch mode